import React, { useState } from "react";
import api from "../../api/axios";

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },

  modal: {
    background: "#fff",
    width: "800px",
    maxHeight: "90vh",
    overflowY: "auto",
    borderRadius: "8px",
    padding: "24px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },

  field: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "16px",
  },

  label: {
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "6px",
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "20px",
  },

  createBtn: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  closeBtn: {
    background: "#e5e7eb",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
  },
};


const ServiceTagModal = ({ onClose }) => {
  const [form, setForm] = useState({
    customer_name: "",
    customer_address: "",
    customer_contact: "",
    amount: "",
    customer_email: "",
    equipment_name: "",
    problems: "",
    accessories: "",
    technical_task: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
      try {
        const payload = {
          ...form,
          customer_contact: `977${form.customer_contact}`,
        };

        await api.post("companyblog/admin/create/", payload);
        alert("Service Tag Created Successfully");
        onClose();
      } catch (err) {
        console.error(err);
        alert("Failed to create service tag");
      }
    };


  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2>Create a maintenance record</h2>

        <div style={styles.grid}>
          <Field label="Customer name *">
            <input name="customer_name" onChange={handleChange} />
          </Field>

          <Field label="Address *">
            <input name="customer_address" onChange={handleChange} />
          </Field>

          {/* <Field label="Contact number *">
            <input name="customer_contact" onChange={handleChange} />
          </Field> */}
          <Field label="Contact number *">
              <div style={{ display: "flex", gap: "6px" }}>
                <input value="+977" disabled style={{ width: "60px", background: "#f3f4f6", textAlign: "center",}}
                />
                <input name="customer_contact" placeholder="9867838662" maxLength={10} onChange={(e) => {const value = e.target.value.replace(/\D/g, "");setForm({ ...form, customer_contact: value });}}
                />
              </div>
            </Field>

            <Field label="Amount (NPR)"><input name="amount" type="number" placeholder="0.00" min="0" onChange={(e) =>setForm({ ...form, amount: e.target.value })}/>
            </Field>

          <Field label="Email">
            <input name="customer_email" onChange={handleChange} />
          </Field>

          <Field label="Equipment Name">
            <input name="equipment_name" onChange={handleChange} />
          </Field>

          <Field label="Problem">
            <input name="problems" onChange={handleChange} />
          </Field>
        </div>

        <Field label="Accessories">
          <input name="accessories" onChange={handleChange} />
        </Field>

        <Field label="Technical Task">
          <textarea
            name="technical_task"
            rows={4}
            onChange={handleChange}
          />
        </Field>

        <div style={styles.actions}>
          <button style={styles.createBtn} onClick={handleSubmit}>
            Create
          </button>
          <button style={styles.closeBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, children }) => (
  <div style={styles.field}>
    <label style={styles.label}>{label}</label>
    {children}
  </div>
);

export default ServiceTagModal;